import { render, staticRenderFns } from "./TradingSetting.vue?vue&type=template&id=7ccf7ddf&scoped=true"
import script from "./TradingSetting.vue?vue&type=script&lang=js"
export * from "./TradingSetting.vue?vue&type=script&lang=js"
import style0 from "./TradingSetting.vue?vue&type=style&index=0&id=7ccf7ddf&prod&lang=scss&scoped=true"
import style1 from "./TradingSetting.vue?vue&type=style&index=1&id=7ccf7ddf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccf7ddf",
  null
  
)

export default component.exports